import showComp from './showComp.jst';
import joinComp from './joinComp.jst';
import regenerateComp from './regenerateComp.jst';

export default {
	showComp,
	joinComp,
	regenerateComp
};